import { Icon } from '~/components';
import { cn } from '~/lib/cn';

interface OverwriteIconProps {
  value?: string;
  className?: string;
}

const OverwriteIcon = (props: OverwriteIconProps): JSX.Element => {
  if (!props.value) {
    return <></>;
  }

  return (
    <Icon
      title={`Rollup value: \n${props.value}`}
      type="marker"
      variant="solid"
      size="sm"
      className={cn('text-body-sm', props.className)}
    />
  );
};

OverwriteIcon.displayName = 'OverwriteIcon';

export { OverwriteIcon };
